module.exports = __webpack_public_path__ + "assets/img/26_725_big.9f3d45bd.jpg";